import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface OrtherInfoState {
  fixedState: number;
}

const LOCALKEY = localKeyInfo.ortherInfo;
const localVoiceInfo = LocalStore.getValue<OrtherInfoState>(LOCALKEY) || {};

export const ortherInfo: OrtherInfoState = {
  fixedState: 0,
  ...localVoiceInfo
};

export const setOrtherInfo: (payload: OrtherInfoState) => IAction<OrtherInfoState> = (payload: OrtherInfoState) => ({
  type: 'setOrtherInfo',
  payload
});

const ortherInfoReducer: Reducer<OrtherInfoState, IAction<any>> = (state = ortherInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setOrtherInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default ortherInfoReducer;
